module.exports = __webpack_public_path__ + "img/offers5.783e219f.webp";